import { useEffect, useState } from "react";
import Text from "./Text";

function Card(props: any) {
    const [classNames, setclassNames] = useState("");

    useEffect(() => {
        let _className = "loop-card";
        if (props.variant) {
            _className += " loop-card-" + props.variant;
        }
        if (props.cardClassName) {
            _className += " " + props.cardClassName;
        }
        setclassNames(_className);
    }, [props.variant, props.cardClassName]);

    return (
        <div className={props.className} id={props.id ? props.id : ""}>
            {props.label ? (
                <div className="d-flex w-100 justify-content-end">
                    <div className="loop-card-label me-4 px-3 py-1">
                        <Text.P2>{props.label}</Text.P2>
                    </div>
                </div>
            ) : null}
            <div
                className={classNames + (props.onClick ? " loop-pointer" : "")}
                style={props.style ? props.style : {}}
                onClick={props.onClick ? props.onClick : () => {}}
            >
                {props.header ? <Header>{props.header}</Header> : null}
                {props.body ? <Body>{props.children}</Body> : props.children}
                {props.footer ? <Footer>{props.footer}</Footer> : null}
            </div>
        </div>
    );
}

export function Header(props: any) {
    return (
        <div
            className={`loop-card-header ${props.hideBorder ? "loop-borderless" : ""}`}
        >
            {props.children}
        </div>
    );
}

export function Body({ className = undefined, ...props }: any) {
    return (
        <div className={"loop-card-body" + (className ? " " + className : "")}>
            {props.children}
        </div>
    );
}

export function Footer(props: any) {
    return (
        <div
            className={
                "loop-card-footer" +
                (props.className ? " " + props.className : "")
            }
        >
            {props.children}
        </div>
    );
}

export function LineCard(props: any) {
    const [classNames, setclassNames] = useState("");
    useEffect(() => {
        let _className = "loop-card-line";
        if (props.className) {
            _className += " " + props.className;
        }
        setclassNames(_className);
    }, []);
    return (
        <div
            className={classNames + (props.onClick ? " loop-pointer" : "")}
            style={props.style ? props.style : {}}
            onClick={props.onClick ? props.onClick : () => {}}
        >
            {props.children}
        </div>
    );
}

export default Object.assign(Card, {
    Body: Body,
    Header: Header,
    Footer: Footer,
    LineCard: LineCard,
});
